<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    class="plus-icon"
    :style="{ '--icon-color': color }"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M5 12h14" />
    <path d="M12 5v14" />
  </svg>
</template>

<script setup>
defineProps({
  size: {
    type: [String, Number],
    default: 16,
  },
  color: {
    type: String,
    default: '#0088cc',
  },
})
</script>

<style scoped>
.plus-icon {
  display: inline-block;
  vertical-align: middle;
  transition: opacity 0.2s;
  color: var(--icon-color, #0088cc);
}

.plus-icon:hover {
  opacity: 0.8;
}
</style>

<style>
/* Make icon white when inside buttons */
a.btn-link .plus-icon,
a.btn-sm .plus-icon,
button.btn-sm .plus-icon,
button.btn-primary .plus-icon {
  color: white !important;
}
</style>
